export default "__VITE_ASSET__1XdbcYv8__"